export const MENTION_USERNAME_PATTERN = '[a-zA-Z0-9._-]{3,20}';
export const MENTION_PATTERN = new RegExp(`(^|[^\\w.@-])@(${MENTION_USERNAME_PATTERN})\\b`, 'g');
export const MENTION_QUERY_PATTERN = /(^|[^\w.@-])@([a-zA-Z0-9._-]*)$/;

export function getActiveMentionQuery(text, cursorPos) {
  const before = String(text || '').slice(0, cursorPos);
  const match = before.match(MENTION_QUERY_PATTERN);
  if (!match) return null;
  return {
    query: match[2],
    start: match.index + match[1].length,
    end: cursorPos,
  };
}

export function insertMention(text, mention, cursorPos) {
  const active = getActiveMentionQuery(text, cursorPos);
  if (!active) return { text, cursorPos };

  const before = text.slice(0, active.start);
  const after = text.slice(active.end);
  const insertion = `@${mention} `;
  const nextText = `${before}${insertion}${after}`;
  const nextCursor = before.length + insertion.length;

  return { text: nextText, cursorPos: nextCursor };
}
